import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { CollectionProxy } from 'spraypaint/lib-esm/proxies';
import ObservedPromise from 'spa-ionata-admin/lib/services/ObservedPromise';
import Category from '../models/Category';

@Module({
  name: 'CategoriesModule',
  namespaced: true,
})
export default class CategoriesModule extends VuexModule {
  itemsPromise = new ObservedPromise<CollectionProxy<Category>>();

  get items(): Category[] {
    return this.itemsPromise.value?.data || [];
  }

  get isLoading() {
    return this.itemsPromise.isPending;
  }

  get error() {
    return this.itemsPromise.error;
  }

  // Bloody vuex-module-decorators crap
  get find() {
    return (id: string): Category | undefined => {
      if (!id) {
        return undefined;
      }
      return this.items.find(item => item.id === id);
    };
  }

  @Mutation
  fetchItems() {
    const promise = Category.where({ isAssigned: true }).all();
    this.itemsPromise = new ObservedPromise(promise);
  }

  @Action
  async fetchItemsIfNeeded() {
    const { isPending, value } = this.itemsPromise;
    if (value != null) {
      return;
    }
    try {
      if (!isPending) {
        this.context.commit('fetchItems');
      }
      await this.itemsPromise.promise;
    } catch {
      // check this.error
    }
  }
}
